import React from "react";
import { Col, Row } from "react-bootstrap";
import { DiJavascript1, DiReact, DiHtml5, DiCss3 } from "react-icons/di";
import {
  SiPython,
  SiSelenium,
  SiPlaywright,
  SiPytest,
  SiTailwindcss,
} from "react-icons/si";
import { FaJava } from "react-icons/fa";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {/* Programming Languages */}
      <Col xs={4} md={2} className="tech-icons">
        <SiPython />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>Python</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>JavaScript</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaJava />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>Java</p>
      </Col>

      {/* Frontend Development */}
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>React.js</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTailwindcss />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>Tailwind CSS</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiHtml5 />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>HTML5</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiCss3 />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>CSS3</p>
      </Col>

      {/* Test Automation */}
      <Col xs={4} md={2} className="tech-icons">
        <SiSelenium />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>Selenium</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPlaywright />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>Playwright</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPytest />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>pytest</p>
      </Col>
    </Row>
  );
}

export default Techstack;